// tslint:disable:no-bitwise
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { OnInit, Renderer2, ElementRef, ChangeDetectorRef, OnDestroy, AfterViewInit } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { LabelModel } from 'src/app/story/models/labels/label.model';
import { filter, takeUntil, map } from 'rxjs/operators';
import { EngineState } from 'src/app/engine/state/engine.state';
import { EngineService, EngineEventsEnum } from 'src/app/engine/engine.service';
import { SelectLabel, SetLabel } from 'src/app/story/state/labels/story.labels.actions';
import { Observable, Subject } from 'rxjs';
import * as Hammer from 'hammerjs';
import { CameraService } from 'src/app/engine/camera.service';
import { StoryLabelsState } from 'src/app/story/state/labels/story.labels.state';
import { FlyToNode } from 'src/app/engine/state/engine.actions';
import { SetCamera, SetZoomed } from 'src/app/engine/state/camera/engine.camera.actions';
import { EngineCameraState } from 'src/app/engine/state/camera/engine.camera.state';
import { LabelPinType } from 'src/app/story/models/labels/label-pin-type.enum';
import { LabelThemeEnum } from 'src/app/story/models/labels/label-theme.enum';
import { ErrandType } from 'src/app/story/models/errands/errand-type.enum';
import * as _ from 'lodash';
var fullOpacity = 1;
var fadeStartAngle = 80;
var maxViewAngle = 100;
var fadeRange = maxViewAngle - fadeStartAngle;
// Hardcoded reference number. The actual pin width is set in label.component.scss.
var pinDiameter = 32;
var pinRadius = pinDiameter / 2;
var LabelStyleClass;
(function (LabelStyleClass) {
    LabelStyleClass["fadeIn"] = "label--fade-in";
    LabelStyleClass["fadeOut"] = "label--fade-out";
    LabelStyleClass["tagLeft"] = "label__tag--left";
    LabelStyleClass["tagRight"] = "label__tag--right";
})(LabelStyleClass || (LabelStyleClass = {}));
var LabelComponent = /** @class */ (function () {
    function LabelComponent(renderer, engineEventsService, cameraService, store, changeDetection) {
        this.renderer = renderer;
        this.engineEventsService = engineEventsService;
        this.cameraService = cameraService;
        this.store = store;
        this.changeDetection = changeDetection;
        this.labelPinType = LabelPinType;
        this.theme = 'classic';
        // Cache position for performance
        this.enginePosition = null;
        // Local expanded / collapsed references
        this.descriptionCollapsed = false;
        this.tagCollapsed = false;
        // Pin
        this.pinDragging = false;
        // Reference to hammer event managers so we can unbind on destroy
        this.hammerManagers = [];
        this.ngUnsubscribe = new Subject();
    }
    Object.defineProperty(LabelComponent.prototype, "label", {
        get: function () {
            return this._label;
        },
        set: function (value) {
            var isValueNull = Object.keys(value).length === 0;
            var isLabelNull = this.label == null || Object.keys(this.label).length === 0;
            if (isValueNull && !isLabelNull) {
                this._label = value;
                this.destroyLabel();
            }
            else if (!isValueNull) {
                this._label = value;
                this.initLabel(this.label);
            }
        },
        enumerable: true,
        configurable: true
    });
    LabelComponent.prototype.ngOnInit = function () {
        this.initListeners();
    };
    LabelComponent.prototype.ngAfterViewInit = function () {
        // We're using HammerJS to handle drag events for better touch compatibility. However
        // this results in Hammer 'tap' events preceeding Angular 'click' events, which can
        // lead to duplicate or unexpected click handling. So for labels, all interaction events are 
        // now handled through HammerJS, and initialized below. 
        this.bindTagEvents();
        this.bindPinEvents();
    };
    LabelComponent.prototype.ngOnDestroy = function () {
        this.destroyLabel();
        // Unsubscribe
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    LabelComponent.prototype.destroyLabel = function () {
        // Destroy event handlers bound outside of angular
        this.hammerManagers.forEach(function (manager) { return manager.destroy; });
        this.hammerManagers = [];
        // Delete markers in the engine
        this.deleteMarker(this.marker);
    };
    LabelComponent.prototype.initListeners = function () {
        var _this = this;
        // Handle selected label
        this.selectedLabel$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (label) { return _this.handleLabelSelected(label); });
        // Cache local copy of engine position any time it updates, for performance
        this.enginePosition$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (position) {
            _this.enginePosition = position;
        });
        // An exception of allowing another component to subscribe directly to engine events. 
        // Since marker position changes with any motion from the engine, running events through 
        // the store would create an unneccessary performance overhead. 
        this.engineEventsService.getEvent(EngineEventsEnum.SceneMarkersUpdated)
            .pipe(filter(function () {
            return _this.label != null && _this.enginePosition != null;
        }), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.setCanvasPos();
        });
    };
    LabelComponent.prototype.bindTagEvents = function () {
        var _this = this;
        // Create a HammerJS manager so we can custom define single and double click
        var mc = new Hammer(this.tagRef.nativeElement, { domEvents: true });
        mc.get('pan').set({ direction: Hammer.DIRECTION_ALL, threshold: 3 });
        mc.on('pan', function (event) {
            event.srcEvent.stopPropagation();
            if (!_this.cachedTagOffset) {
                _this.cachedTagOffset = _this.label.offset;
            }
            var offset = [
                _this.cachedTagOffset[0] + event.deltaX,
                _this.cachedTagOffset[1] + event.deltaY
            ];
            _this.label.offset = offset;
            if (event.isFinal) {
                _this.cachedTagOffset = null;
                _this.store.dispatch(new SetLabel(_this.label));
            }
        });
        mc.on('tap', function (event) {
            event.srcEvent.preventDefault();
            event.srcEvent.stopPropagation();
            // Hack to make expand button work differently from rest of tag.
            // Normally wouldn't have to do this, but HammerJS creates very strange
            // event handling loops. 
            if (event.target.parentNode.nodeName === 'BUTTON') {
                _this.toggleDescription();
                // this.changeDetection.markForCheck();
            }
            else {
                _this.selectLabel();
            }
        });
        this.hammerManagers.push(mc);
    };
    LabelComponent.prototype.bindPinEvents = function () {
        var _this = this;
        // Create a HammerJS manager so we can custom define single and double click
        var mc = new Hammer(this.pinRef.nativeElement);
        mc.get('pan').set({ direction: Hammer.DIRECTION_ALL, threshold: 0 });
        mc.on('pan', function (event) {
            event.srcEvent.stopPropagation();
            // While pinDragging is true, setCanvasPos won't fire, which allows us to 
            // change the pin X and Y translation without interference from the engine.
            _this.pinDragging = true;
            var _a = event.changedPointers[0], layerX = _a.layerX, layerY = _a.layerY;
            layerX = layerX - pinRadius;
            layerY = layerY - pinRadius;
            // Marker is updated by the engine every tick, so we have to kill it or else the engine
            // will overwrite our changes. 
            if (_this.marker) {
                _this.deleteMarker(_this.marker);
            }
            // Manually update the pin position to the mouse cursor position
            _this.renderer.setStyle(_this.labelContainerRef.nativeElement, 'transform', "translate(" + layerX + "px, " + layerY + "px)");
            if (event.isFinal) {
                _this.pinDragging = false;
                var label = __assign({}, _this.label);
                // If the pin is dropped on a node, update the position. Otherwise just revert the pin back to 
                // it's original location.
                var hit = Human.renderer.pick.pick({ canvasPos: [layerX, layerY], rayPick: true });
                if (hit.objectId) {
                    label.dir = _this.cameraService.getDirection(hit);
                    label.objectId = hit.objectId;
                    label.barycentric = [hit.barycentric[0], hit.barycentric[1], hit.barycentric[2]];
                    label.pos = [hit.worldPos[0], hit.worldPos[1], hit.worldPos[2]];
                    label.primitiveIndex = hit.primitiveIndex;
                }
                _this.store.dispatch(new SetLabel(label));
            }
        });
        mc.on('tap', function (event) {
            event.srcEvent.preventDefault();
            event.srcEvent.stopImmediatePropagation();
            _this.selectLabel();
        });
        this.hammerManagers.push(mc);
    };
    LabelComponent.prototype.initLabel = function (label) {
        this.initMarker(label);
        this.initObjectSubscription(label);
        this.ensureObjectId(label);
        this.descriptionCollapsed = label.collapseDescription;
        this.tagCollapsed = label.hideTag;
    };
    LabelComponent.prototype.initMarker = function (label) {
        if (this.marker) {
            this.deleteMarker(this.marker);
        }
        this.marker = Human.scene.markers.create({
            pos: label.pos,
            dir: label.dir,
            objectId: label.objectId,
            primitiveIndex: label.primitiveIndex,
            barycentric: label.barycentric,
            renderableIndex: label.renderableIndex || 0
        });
    };
    // labels should always have an objectId
    LabelComponent.prototype.ensureObjectId = function (label) {
        if (!label.objectId) {
            var hit_1 = Human.renderer.pick.pick({ canvasPos: [this.marker.canvasPos[0], this.marker.canvasPos[1]], rayPick: true });
            label.objectId = hit_1.objectId;
            label.states.forEach(function (labelState) {
                labelState.errands.forEach(function (errand) {
                    if (errand.type === ErrandType.flyToObject) {
                        errand.value = hit_1.objectId;
                    }
                });
            });
            this.store.dispatch(new SetLabel(label));
        }
    };
    LabelComponent.prototype.initObjectSubscription = function (label) {
        var _this = this;
        if (this.object$) {
            this.object$.unsubscribe();
        }
        // Listen to attached node and check for visibility Don't show labels with
        // hidden nodes 
        // #NOTE: [EM] This information should be available by the
        // marker and is more reliable, since view-graph node does not necessarily
        // map 1-to-1 for every scene graph object
        if (label.objectId) {
            this.object$ = this.store.select(EngineState.getViewGraphNode)
                .pipe(map(function (filterFn) { return filterFn(label.objectId); }), filter(function (node) { return !!node; }), takeUntil(this.ngUnsubscribe))
                .subscribe(function (node) {
                _this.renderer.setStyle(_this.labelContainerRef.nativeElement, 'display', node.boolState.shown ? 'block' : 'none');
            });
        }
    };
    LabelComponent.prototype.deleteMarker = function (marker) {
        Human.scene.markers.delete(marker.id);
        this.marker = null;
    };
    LabelComponent.prototype.toggleDescription = function (open) {
        open = (typeof open === 'undefined') ? !this.descriptionCollapsed : open;
        this.descriptionCollapsed = open;
    };
    LabelComponent.prototype.handleLabelSelected = function (label) {
        var _this = this;
        var isSelected = (label && label.id === this.label.id);
        var errands = _.get(label, 'states[1].errands');
        var cameraLocked = this.store.selectSnapshot(EngineCameraState.getLockCamera);
        // Fly to
        if (isSelected && errands && !cameraLocked) {
            errands.forEach(function (errand) {
                switch (errand.type) {
                    case ErrandType.flyToObject:
                        _this.flyToObject(errand.value);
                        break;
                    case ErrandType.flyToCamera:
                        _this.flyToPosition(errand.value);
                        break;
                }
                _this.store.dispatch(new SetZoomed(true));
            });
        }
        // Expand
        if (this.label.expandTag && this.label.hideTag) {
            this.tagCollapsed = !isSelected;
        }
        else {
            this.tagCollapsed = this.label.hideTag;
        }
        // Show description
        if (this.label.showDescription && this.label.collapseDescription) {
            this.descriptionCollapsed = !isSelected;
        }
        else {
            this.descriptionCollapsed = this.label.collapseDescription;
        }
    };
    LabelComponent.prototype.flyToObject = function (objectId) {
        var graph = this.store.selectSnapshot(EngineState.getViewGraph);
        var node = this.engineEventsService.getNode(graph, objectId);
        this.store.dispatch(new FlyToNode(node));
    };
    LabelComponent.prototype.flyToPosition = function (cameraPosition) {
        this.store.dispatch(new SetCamera(cameraPosition));
    };
    LabelComponent.prototype.setCanvasPos = function () {
        if (this.pinDragging || !this.marker) {
            return;
        }
        this.depth = -this.marker.viewPos[2];
        // The position can update the display state via the inView property
        // Only call if inView has changed
        var inView = !this.isOccluded();
        if (inView !== this.inView) {
            this.inView = inView;
            this.setDisplay(inView);
        }
        // this.setOpacity();
        this.setElementPosition();
        this.setTagPosition();
        this.setWirePosition();
        // Finally, notify
        this.positionUpdate = {
            id: this.label.id,
            canvasPos: this.marker.canvasPos
        };
        // This is fired for the API's consumption
        // We have to use Human.events in order to hook into its event system
        // this.engineEventsService.fireEvent(EngineEventsEnum.HotspotsPositionUpdated, this.positionUpdate);
    };
    LabelComponent.prototype.selectLabel = function () {
        var previousLabel = this.store.selectSnapshot(StoryLabelsState.getSelectedLabel);
        // Clicking same label to unselect
        if (previousLabel && previousLabel.id === this.label.id) {
            this.store.dispatch(new SelectLabel(null));
        }
        else {
            this.store.dispatch(new SelectLabel(this.label));
        }
    };
    LabelComponent.prototype.isOccluded = function () {
        return (this.label.occludable &&
            (Math.abs(this.marker.viewAngle) > maxViewAngle ||
                this.marker.occluded ||
                this.depth < 0));
    };
    /**
     * Show and hide labels
     */
    LabelComponent.prototype.setDisplay = function (transition) {
        var labelEl = this.labelRef.nativeElement;
        // Remove any previous transition classes
        this.renderer.removeClass(labelEl, LabelStyleClass.fadeIn);
        this.renderer.removeClass(labelEl, LabelStyleClass.fadeOut);
        if (transition) {
            var cssClass = (this.inView) ? LabelStyleClass.fadeIn : LabelStyleClass.fadeOut;
            this.renderer.addClass(labelEl, cssClass);
            this.renderer.setStyle(labelEl, 'visibility', 'visible');
        }
        else {
            var display = (this.inView) ? 'visible' : 'hidden';
            this.renderer.setStyle(labelEl, 'visibility', display);
        }
        // This is fired for the API's consumption
        // We have to use Human.events in order to hook into its event system
        var displayUpdateEvent = {
            id: this.label.id,
            inView: this.inView,
            shown: this.inView
        };
        Human.events.fire('hotspots.displayUpdated', displayUpdateEvent);
    };
    LabelComponent.prototype.setOpacity = function () {
        var opacity = fullOpacity;
        if (this.marker.viewAngle >= fadeStartAngle) {
            var angleDiff = this.marker.viewAngle - fadeStartAngle;
            var scaledOpacity = (angleDiff / fadeRange) * fullOpacity;
            opacity = Math.max(1 - scaledOpacity, 0);
        }
        this.renderer.setStyle(this.labelContainerRef.nativeElement, 'opacity', opacity);
    };
    LabelComponent.prototype.setElementPosition = function () {
        var markerPos = this.marker.canvasPos;
        this.renderer.setStyle(this.labelContainerRef.nativeElement, 'transform', "translate(" + markerPos[0] + "px, " + markerPos[1] + "px)");
    };
    LabelComponent.prototype.setTagPosition = function () {
        var offset = this.label.offset;
        var tagWidth = this.tagRef.nativeElement.offsetWidth;
        var side = (this.label.offset[0] > 0) ? 'left' : 'right';
        switch (side) {
            case 'left':
                this.renderer.setStyle(this.tagRef.nativeElement, 'transform', "translate(" + (16 + offset[0]) + "px, " + offset[1] + "px)");
                break;
            case 'right':
                this.renderer.setStyle(this.tagRef.nativeElement, 'transform', "translate(" + (16 + offset[0] - tagWidth) + "px, " + offset[1] + "px)");
                break;
        }
    };
    LabelComponent.prototype.setWirePosition = function () {
        // tslint:disable-next-line:prefer-const
        var _a = __read(this.label.offset, 2), x = _a[0], y = _a[1];
        // For annotation and hotspot, move line down to below title
        switch (this.label.theme) {
            case LabelThemeEnum.Annotation:
            case LabelThemeEnum.Classic:
                var height = this.titleRef.nativeElement.offsetHeight - 16 - 2; // 16px is half of pin, 2 is border
                y += height;
                break;
        }
        var wireLength = Math.sqrt(x * x + y * y);
        this.renderer.setStyle(this.wireRef.nativeElement, 'width', wireLength + "px");
        this.renderer.setStyle(this.wireRef.nativeElement, 'transform', "rotate(" + Math.atan2(y, x) + "rad)");
    };
    __decorate([
        Select(EngineState.getEnginePosition),
        __metadata("design:type", Observable)
    ], LabelComponent.prototype, "enginePosition$", void 0);
    __decorate([
        Select(StoryLabelsState.getSelectedLabel),
        __metadata("design:type", Observable)
    ], LabelComponent.prototype, "selectedLabel$", void 0);
    return LabelComponent;
}());
export { LabelComponent };
